/* SEARCH RESULTS PAGE PRODUCT DETAIL SCRIPTS */
// Search result product details on hover

function handleize(text) {
  return text.toString().toLowerCase()
             .replace(/\s+/g, '-')           // Replace spaces with -
             .replace(/[^\w\-]+/g, '-')      // Replace all non-word chars with -
             .replace(/\-\-+/g, '-')         // Replace multiple - with single -
             .replace(/^-+/, '')             // Trim - from start of text
             .replace(/-+$/, '');            // Trim - from end of text
}


function addSize(url, size) {
  return url.replace(`.png`,`_${size}.png`).replace(`.jpg`,`_${size}.jpg`)
}

const imageSizes = [
  { width: 480, size: '222x222' },
  { width: 800, size: '382x382' },
  { width: 880, size: '310x310' },
  { width: 1206, size: '433x433' },
  { width: 99999, size: '320x320' },
]

$(document).on("click tap", ".product-card--swatches img", function() {
  let fullImageSrc = $(this).data('full');
  let variantId = $(this).data('variant');
  let productId = $(this).data('parent');
  var productUrl = $(`#product-link--${productId}`).attr('href');
  var questionMarkIndex = productUrl.indexOf("?");
  var productNewUrl = questionMarkIndex !== -1 ? `${productUrl.substring(0, questionMarkIndex)}?variant=${variantId}` : `${productUrl}?variant=${variantId}`;
  $(this).closest('.product-card').find('.product-card--picture img').attr('srcset', null).attr('src', fullImageSrc)
  $(`#product-link--${productId}`).attr('href',productNewUrl);
  $(this).addClass('active').siblings().removeClass('active');
});

$(document).on("click tap", ".product-card--swatches .more-swatches", function() {
  $(this).closest('.product-card--swatches').toggleClass('active');
});

// mobile facet toggler
$("#mobile-facets-toggler").on("click", function() {
  $("#facets-wrapper").toggleClass("open");
  $("#mobile-facets-toggler .toggler-mode").toggleClass("hidden");
});

$(".ais-facet--label")
  .sort(function(a, b) {
    if (a.textContent < b.textContent) {
      return -1;
    } else {
      return 1;
    }
  })
  .appendTo(".ais-RefinementList");

$(document).on("ready", function() {
  $("div.ais-RefinementList--noRefinement")
    .parent()
    .parent()
    .hide();
});


// custom sort and filter for mobile


// on document ready
$(document).ready(function() {

  async function scrollElementToTop(element, options) {
    return new Promise((resolve) => {
      const elementTop = element.getBoundingClientRect().top;
      if (elementTop > 0) {
      const offset = 60;
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: elementTop, ...options });
      setTimeout(resolve, 100); // Adjust the timeout as needed
      } else {
      resolve();
      }
    });
  }

  const aisPage = document.querySelector('.ais-page'); 

  // build mobile sort and filter wrapper
  const mobileSortFilter = document.createElement('div');
  mobileSortFilter.classList.add('sort-filter-container');

  // build mobile sort
  const mobileSort = document.createElement('div');
  mobileSort.classList.add('custom-sort');
  mobileSort.innerHTML = `
    <i class="sb-icon-sort" alt="Show sort options" aria-hidden="true"></i>
    <span class="flex-grow">Sort</span>
    <i class="sb-icon-chevron-down text-3xl" alt="Show sort options" aria-hidden="true"></i>`;

  // build mobile filter
  const mobileFilter = document.createElement('div');
  mobileFilter.classList.add('mobile-filter');
  mobileFilter.innerHTML = `
    <i class="sb-icon-filter" alt="Show filters" aria-hidden="true"></i>
    <span class="flex-grow">Filter</span>
    <i class="sb-icon-chevron-down text-3xl" alt="Show filters" aria-hidden="true"></i>`;
  
  // build mobile sort options wrapper
  const mobileSortOptionsWrapper = document.createElement('div');
  mobileSortOptionsWrapper.classList.add('custom-sort-options');

  // add mobile sort and filter to dom 
  mobileSortFilter.appendChild(mobileSort);
  mobileSortFilter.appendChild(mobileFilter);
  mobileSortFilter.appendChild(mobileSortOptionsWrapper);
  document.querySelector('.ais-search-header').appendChild(mobileSortFilter);

  // listen for filter toggle
  mobileFilter.addEventListener('click', function() {
    scrollElementToTop(aisPage, { behavior: 'instant', block: 'start' }).then(() => {
      document.querySelector('.ais-facets').classList.toggle('ais-facets__shown');
      mobileSortFilter.classList.remove('sort-open');
      mobileSortFilter.classList.toggle('filter-open');
      mobileSortOptionsWrapper.innerHTML = '';
      document.body.style.overflow = mobileSortFilter.classList.contains('filter-open') ? 'hidden' : '';
    });
  });

  // listen for filter applied
  const applyFiltersButton = document.querySelector('.ais-mobile-apply-button');
  applyFiltersButton.addEventListener('click', () => {
    document.querySelector('.ais-facets').classList.remove('ais-facets__shown');
    mobileSortFilter.classList.remove('filter-open');
    mobileSortFilter.classList.remove('sort-open');
    document.body.style.overflow = '';
  });
  
  // listen for sort toggle
  mobileSort.addEventListener('click', function() {

    // get sort options
    function getSortOptions() {
      if (!mobileSortFilter.classList.contains('sort-open')) return '';
      const sortSelect = document.querySelector('.ais-SortBy-select');
      let sortOptionsHTML = '';
      sortSelect.querySelectorAll('option').forEach((option) => {
        sortOptionsHTML += `<div class="custom-sort-option" data-value="${option.value}" data-selected="${option.selected}"><span>${option.text}</span></div>`;
      });
      return sortOptionsHTML;
    }

    // hide filters
    document.querySelector('.ais-facets').classList.remove('ais-facets__shown'); 
    mobileSortFilter.classList.remove('filter-open'); 
    
    // toggle sort options
    mobileSortFilter.classList.toggle('sort-open');
    document.body.style.overflow = mobileSortFilter.classList.contains('sort-open') ? 'hidden' : '';
    mobileSortOptionsWrapper.innerHTML = getSortOptions();

    // close sort panel when clicking outside of it
    if (mobileSortFilter.classList.contains('sort-open')) {
      function handleSortClickOutside(e) {
        if (!mobileSortFilter.contains(e.target)) {
          mobileSortFilter.classList.remove('sort-open');
          document.body.style.overflow = '';
          mobileSortOptionsWrapper.innerHTML = getSortOptions();
          document.removeEventListener('click', handleSortClickOutside);
        }
      }
      setTimeout(() => document.addEventListener('click', handleSortClickOutside), 0);
    }


    // listen for sort option click
    const mobileSortOptions = document.querySelectorAll('.custom-sort-option')
    mobileSortOptions.forEach((option) => {
      option.addEventListener('click', function() {

        // if option is already selected, do nothing
        if (this.dataset.selected === 'true') return;

        new Promise((resolve) => { window.scrollTo({ top: 0, behavior: 'smooth' }); setTimeout(resolve, 500); }).then(() => {
          mobileSortOptions.forEach((option) => option.dataset.selected = 'false'); // deselect all options
          this.dataset.selected = 'true'; // select current option
          const sortSelect = document.querySelector('.ais-SortBy-select');
          sortSelect.value = this.dataset.value; // set sort select value
          sortSelect.dispatchEvent(new Event('change')); // trigger change event
          
          setTimeout(() => {
            mobileSortFilter.classList.remove('sort-open'); // close sort options
            document.body.style.overflow = ''; // remove overflow hidden
            mobileSortOptionsWrapper.innerHTML = getSortOptions();
          }, 500);
        });
      });
    });

  });

  // make mobile sort and filter sticky
  window.addEventListener('scroll', function() {
    const aisPageOffsetTop = aisPage.getBoundingClientRect().top;
    const aisPageOffsetBottom = aisPage.getBoundingClientRect().bottom;
    if (aisPageOffsetTop < 65 && aisPageOffsetBottom > 65 && window.innerWidth <= 768) {
      mobileSortFilter.style.position = 'fixed';
      mobileSortFilter.style.top = '122px';
      mobileSortFilter.style.left = '0';
    } else {
      mobileSortFilter.style.position = 'relative';
      mobileSortFilter.style.top = '';
      mobileSortFilter.style.left = '';
    }
  });

  // open first facet
  const firstFacet = document.querySelector('.ais-facets > [class^="ais-facet-"]');
  if (firstFacet) firstFacet.classList.add('open');

  // listen for facet toggling
  const facetHeaders = document.querySelectorAll('.ais-facet--header');
  facetHeaders.forEach((header) => {
    header.addEventListener('click', function() {
      const parentFacet = this.parentElement;
      parentFacet.classList.toggle('open');
    });
  });


  // instore pickup widget
  const inStorePickupToggle = document.getElementById('in-store-pickup-toggle');


  let selectedStoreShopifyId = stores.find(s => s.name === userPreferences?.store?.name)?.shopify_id || null;
  inStorePickupToggle.dataset.selectedStore = selectedStoreShopifyId || '';
  algoliaShopify.selectedStoreShopifyId = selectedStoreShopifyId;

  // auto select delivery method based on user preferences
  if (userPreferences.deliveryMethod === 'pickup' && inStorePickupToggle) {
    inStorePickupToggle.checked = true;
    inStorePickupToggle.dispatchEvent(new Event('change', { bubbles: true }));
  }
  
  // listen for instore pickup toggle change
  if (inStorePickupToggle) {
    inStorePickupToggle.addEventListener('change', () => {
      userPreferences.deliveryMethod = inStorePickupToggle.checked ? 'pickup' : null;
      localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));
    }); 
  }

  // update data attributes
  updateUserPrefrencesDataAttributes();

  // listen for users prefered store selection
  const storeRadioButtons = document.querySelectorAll(`input[data-store-name][type="radio"]`);
  storeRadioButtons.forEach((el) => {
    if (el.dataset.storeName === userPreferences?.store?.name) el.checked = true;
    el.addEventListener('change', function() {
      if (this.checked) {

        // update selected store shopify id
        selectedStoreShopifyId = stores.find(s => s.name === this.dataset.storeName)?.shopify_id || null;
        inStorePickupToggle.dataset.selectedStore = selectedStoreShopifyId || '';
        algoliaShopify.selectedStoreShopifyId = selectedStoreShopifyId;

        // update user preferences
        if (!userPreferences.store) userPreferences.store = {};
        userPreferences.store.name = this.dataset.storeName;
        userPreferences.store.storePrefix = this.dataset.storePrefix;
        userPreferences.store.erBranchId = this.dataset.erBranchId;
        localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));

        // update data attributes
        updateUserPrefrencesDataAttributes();
      }
    });
  });
  

});